module.exports = __webpack_public_path__ + "img/IND-B-1-I.4d2b622d.png";